const spUp = async (updates, attributes = {}) => {
  window.spU = true;
  const sid = 'minicart-form', cart = document.getElementById(sid);
  try {
    const res = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates, attributes, sections: sid, sections_url: window.location.pathname })
    });
    const data = await res.json();
    const newCart = new DOMParser().parseFromString(data.sections?.[sid] || '', 'text/html').getElementById(sid);
    if (cart && newCart) cart.innerHTML = newCart.innerHTML;
    else window.location.reload();
    if (data.item_count !== undefined) {
      document.querySelectorAll('.cart-count, .cart-count-drawer, .header__cart-count').forEach(el => el.innerHTML = `(${data.item_count})`);
    }
  } catch { window.location.reload(); }
  setTimeout(() => window.spU = false, 500);
};
const spCheck = () => {
  const d = document.getElementById('sp-cart-data');
  if (!d || window.spU) return;
  const n = +d.dataset.normalItems, c = d.dataset.inCart === 'true', r = d.dataset.rejected === 'true';
  if (n > 0 && !c && !r) spUp({ [d.dataset.vid]: 1 });
  else if (n === 0 && c) spUp({ [d.dataset.vid]: 0 });
};
spCheck();
let spTimer;
new MutationObserver(() => {
  clearTimeout(spTimer);
  spTimer = setTimeout(spCheck, 800);
}).observe(document.body, { childList: true, subtree: true });
document.addEventListener('change', (e) => {
  if (e.target?.id !== 'shippingProtectionToggle') return;
  e.preventDefault(); e.stopPropagation();
  e.target.parentElement.style.opacity = '0.5';
  e.target.style.pointerEvents = 'none';
  spUp({ [e.target.dataset.variantId]: e.target.checked ? 1 : 0 }, { 'sp_rejected': e.target.checked ? 'false' : 'true' });
}, true);

function refreshCartSaving() {
  fetch(`${routes.cart_url}?section_id=minicart-form`)
    .then((response) => response.text())
    .then((text) => {
      const html = new DOMParser().parseFromString(text, 'text/html');
      const newSaving = html.querySelector('#cart-saving-block');
      const currentSaving = document.querySelector('#cart-saving-block');

      if (newSaving) {
        if (currentSaving) {
          currentSaving.outerHTML = newSaving.outerHTML;
        } else {
          document.querySelector('[data-cart-summary]')
            ?.insertAdjacentHTML('afterend', newSaving.outerHTML);
        }
      } else if (currentSaving) {
        currentSaving.remove();
      }
    })
    .catch((e) => console.error('refreshCartSaving error:', e));
}